import {
  FETCH_AVAIL,
  FETCH_AVAIL_FAILURE,
  FETCH_AVAIL_SUCCESS,
  TOGGLE_AVAIL_MODAL,
  DELETE_DAYOFF,
  DELETE_DAYOFF_SUCCESS,
  DELETE_DAYOFF_FAILURE,
  ADD_DAYOFF,
  ADD_DAYOFF_SUCCESS,
  ADD_DAYOFF_FAILURE,
} from "./constants";

export const toggleAvailModal = (payload) => ({
  type: TOGGLE_AVAIL_MODAL,
  payload,
});
// List
export const fetchAvail = (payload, onSuccess) => ({
  type: FETCH_AVAIL,
  payload,
  onSuccess,
});
export const fetchAvailSuccess = (payload) => ({
  type: FETCH_AVAIL_SUCCESS,
  payload,
});
export const fetchAvailFailure = (payload) => ({
  type: FETCH_AVAIL_FAILURE,
  payload,
});
export const deleteDayOff = (payload, onDelete) => ({
  type: DELETE_DAYOFF,
  payload,
  onDelete,
});
export const deleteDayOffSuccess = (payload) => ({
  type: DELETE_DAYOFF_SUCCESS,
  payload,
});
export const deleteDayOffFailure = (payload) => ({
  type: DELETE_DAYOFF_FAILURE,
  payload,
});
export const addDayOff = (payload, onAdd) => ({
  type: ADD_DAYOFF,
  payload,
  onAdd,
});
export const addDayOffSuccess = (payload) => ({
  type: ADD_DAYOFF_SUCCESS,
  payload,
});
export const addDayOffFailure = (payload) => ({
  type: ADD_DAYOFF_FAILURE,
  payload,
});
